import React from 'react';
import PropTypes from 'prop-types';
import iconSrc from '../../utils/iconSrc';
import LinkHandler from '../link-handler';

// Styles
import { VisuallyHidden } from '../styled/accessibility';
import { UnorderedList, ListItem, SVGIcon } from './styles';

const Pagination = ({ current, all, previous = [], next = [] }) => (
  <nav aria-label="pagination">
    <UnorderedList>
      {previous.length !== 0 ? (
        <ListItem key="pagination-prev" previous>
          <LinkHandler
            link={{
              path: previous.length
                ? previous[previous.length - 1].path
                : all[0].path,
            }}
          >
            <VisuallyHidden>Previous page</VisuallyHidden>
            <SVGIcon src={iconSrc('chevron-left')} />
          </LinkHandler>
        </ListItem>
      ) : null}

      {/* Previous */}
      {previous.map(({ index, path }) => (
        <ListItem key={`pagination-number-${index}`}>
          <LinkHandler link={{ path }} ariaLabel={`Page ${index}`}>
            {index}
          </LinkHandler>
        </ListItem>
      ))}

      {/* Active page */}
      <ListItem active aria-current="page">
        {current}
      </ListItem>

      {/* Next */}
      {next.map(({ index, path }) => (
        <ListItem key={`pagination-number-${index}`}>
          <LinkHandler link={{ path }} ariaLabel={`Page ${index}`}>
            {index}
          </LinkHandler>
        </ListItem>
      ))}

      {next.length !== 0 ? (
        <ListItem key="pagination-next">
          <LinkHandler
            link={{ path: next.length ? next[0].path : all[0].path }}
            next
          >
            <VisuallyHidden>Next page</VisuallyHidden>
            <SVGIcon src={iconSrc('chevron-right')} />
          </LinkHandler>
        </ListItem>
      ) : null}
    </UnorderedList>
  </nav>
);

Pagination.propTypes = {
  current: PropTypes.number.isRequired,
  all: PropTypes.array.isRequired,
  previous: PropTypes.array,
  next: PropTypes.array,
};

export default Pagination;
